/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useAdminDatasetsCategoriesPageStyles = makeStyles({
  title: {
    marginBottom: '30px',
  },
  loaderContainer: {
    height: '100%',
    maxHeight: '500px',
    minHeight: '150px',
  },
  thumbnail: {
    width: '30px',
    height: '30px',
  },
});
